import { styled } from '@mui/material/styles';
import { SvgLogoBusiness } from '@noah-labs/fe-shared-ui-assets/images/LogoBusiness';

export const BusinessLogo = styled(SvgLogoBusiness)(({ theme }) => ({
  display: 'block',
  height: '19px',
  paddingLeft: theme.spacing(2),
}));
